export default "/images/powered-by-digitickets.svg?ed30978be5d264ffbd6a58d16f9ba150";